import React from "react";
import { useHistory } from "react-router-dom";

import * as S from "./styles";
import { IProps } from "./types";
import { getDBIdFromGraphqlId, slugify } from "@utils";
import { productsUrl, productListByTagUrl } from "@src/app/routes";

const ProductTag: React.FC<IProps> = (
  {
    tagName,
    tagId
  }: IProps) => {
  const history = useHistory()
  const slug = slugify(tagName);
  const tagDbId = getDBIdFromGraphqlId(tagId, 'Tag');
  const uri = `${slug}-${tagDbId}`;
  const handleClick = () => {
    history.push(`${productsUrl}tag/${uri}`)
  }
  return (
    <S.Button onClick={handleClick}># {tagName}</S.Button>
  )
};

export { ProductTag }